import { Chip } from "@dropbox/dig-components/chip";
import { Text } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import styles from "./FilterChip.module.css";

export function FilterChip({
  filterIcon,
  title,
}: {
  filterIcon: JSX.Element;
  title: string | JSX.Element | undefined;
}) {
  return (
    <Box className={styles.filterChip}>
      <Chip variant="standard" size="medium">
        <Chip.IconAccessory>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            columnGap="Micro XSmall"
          >
            {filterIcon}
          </Box>
        </Chip.IconAccessory>
        <Chip.Content>
          <Text size="large" color="standard">
            {title}
          </Text>
        </Chip.Content>
      </Chip>
    </Box>
  );
}
